export default __webpack_public_path__ + "static/media/add-test-disabled.b5644b9e.svg";